let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("Pmv83")).then(() => parcelRequire('kepuY'));